import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LineChart from '../components/line-chart';
import PeriodDropdown from '../components/period-dropdown';
import { aggregateAnnualData } from './chart-helper';

class BotChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.data.slice(-12),
      period: 'monthly'
    };

    this.handlePeriodChange = this.handlePeriodChange.bind(this);
  }

  handlePeriodChange(period) {
    let data = [];

    switch (period) {
      case 'monthly':
        data = this.props.data.slice(-12);
        break;
      case 'annual':
        data = aggregateAnnualData(this.props.data);
        break;
      default:
        data = this.props.data;
        break;
    }
    this.setState({ period, data });
  }

  render() {
    const seriesName = 'Bot Clients';
    return (
      <div>
        <h5 className="sub-header-with-controls">
          {"View Number of Bot Clients By "}
          <PeriodDropdown
            period={this.state.period}
            handlePeriodChange={this.handlePeriodChange}
          />
          {" Periods"}
        </h5>
        <LineChart data={this.state.data} seriesName={seriesName} />
      </div>
    );
  }
}

BotChart.propTypes = {
  data: PropTypes.array.isRequired,
};

export default BotChart;
